import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import API_URL from "../../../api/API";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SingleSelectExerciseList from "../../component/SingleSelectExerciseList";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { GoArrowLeft } from "react-icons/go";
import { FiEdit2 } from "react-icons/fi";
import { MdAdd, MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { RiDeleteBin4Line } from "react-icons/ri";

const DotedSvg = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AdminEditSpeedTrainingFocusTemplate = () => {
  const { staff } = useStaffAuthContext();
  const { template_id } = useParams(); // Get template ID from URL

  const [trainingFocus, setTrainingFocus] = useState("");
  const [trainingPhase, setTrainingPhase] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [editingFocus, setEditingFocus] = useState(false);
  const [editingPhase, setEditingPhase] = useState(false);

  const [tempFocus, setTempFocus] = useState("");
  const [tempPhase, setTempPhase] = useState("");

  const [saveStatus, setSaveStatus] = useState("");

  // At top of component
  const [sprints, setSprints] = useState([]);
  const [exerciseOptions, setExerciseOptions] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [isSavingTemplate, setIsSavingTemplate] = useState(false);

  // New state for rest data
  const [showRestForm, setShowRestForm] = useState(false);
  const [restDuration, setRestDuration] = useState("");
  const [restNotes, setRestNotes] = useState("");

  const [reorderMode, setReorderMode] = useState(false);
  const [openRows, setOpenRows] = useState({});

  const toggleRow = (index) => {
    setOpenRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Dropdown options
  const distances = [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 133, 134, 150, 180, 200,
    220, 250, 300, 350, 400, 450,
  ];

  const intensities = [75, 80, 85, 88, 90, 92, 95, 98, 100];
  const rests = [
    "30s",
    "1m",
    "2m",
    "3m",
    "4m",
    "5m",
    "6m",
    "7m",
    "8m",
    "9m",
    "10m",
    "12m",
    "15m",
    "18m",
    "20",
    "25",
    "30m",
  ];
  const paces = [100, 200, 400];
  const range = (min, max) =>
    Array.from({ length: max - min + 1 }, (_, i) => i + min);

  const addRestRow = () => {
    if (!restNotes) {
      alert("Please fill out rest details.");
      return;
    }

    setSprints((prev) => [
      ...prev,
      {
        type: "Rest", // distinguish from sprint rows
        rest_duration: "", // you can customize this
        rest_notes: restNotes,
      },
    ]);

    setShowRestForm(false); // hide rest form
    setRestNotes(""); // reset notes
  };

  // Add new rest data
  const addRestData = async () => {
    if (!restNotes) {
      alert("Please fill out rest details.");
      return;
    }

    const restData = {
      rest_duration: "",
      rest_notes: restNotes,
      type: "Rest",
    };

    try {
      const res = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_TRAINING_FOCUS_REST}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify(restData),
        },
      );

      const data = await res.json();
      if (res.ok) {
        alert("Rest data saved successfully.");
        setShowRestForm(false); // Hide form after successful submission
        fetchSprints(); // 🔄 Refresh sprints after save
      } else {
        alert("Error saving rest data: " + data.message);
      }
    } catch (error) {
      console.error("Error saving rest data:", error);
      alert("Error saving rest data.");
    }
  };

  const generateTempId = () =>
    `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // Add new row
  const addSprintRow = () => {
    setSprints((prev) => [
      ...prev,
      {
        _id: generateTempId(), // ✅ temp unique id
        sets: 1,
        reps: 1,
        distance: 10,
        pace: 100,
        intensity: 100,
        rest: "1m",
        exercise_id: null,
        notes: "",
      },
    ]);
  };

  // Remove row
  const deleteSprintRow = (index) => {
    setSprints((prev) => prev.filter((_, i) => i !== index));
  };

  // Save template (POST or PUT depending on logic)
  const saveTemplate = async () => {
    try {
      setIsSavingTemplate(true);

      const res = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TEMPLATE_TRAINING_FOCUS_SPRINTS}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            sprints,
          }),
        },
      );

      const data = await res.json();
      if (res.ok) {
        alert("Template saved successfully.");
        fetchSprints(); // 🔄 Refresh sprints after save
      } else {
        alert("Error saving template: " + data.message);
      }
    } catch (error) {
      console.error("Save failed:", error);
      alert("Save failed. Try again.");
    } finally {
      setIsSavingTemplate(false);
    }
  };

  // Fetch exercise options
  useEffect(() => {
    const fetchExercises = async () => {
      try {
        const res = await fetch(`${API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN}`, {
          headers: {
            Authorization: `Bearer ${staff?.token}`,
          },
        });
        const data = await res.json();
        if (res.ok && data?.exercises) {
          setExerciseOptions(data.exercises);

          //  console.log("Exer Options");
        }
      } catch (err) {
        console.error("Error loading exercises:", err);
      }
    };

    fetchExercises();
  }, [staff?.token]);

  const fetchSprints = async () => {
    if (!template_id || !staff?.token) return;

    try {
      const res = await fetch(
        `${API_URL.ADMIN_GET_SPEED_TEMPLATE_TRAINING_FOCUS_SPRINTS}${template_id}`,
        {
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        },
      );

      const data = await res.json();
      console.log(data);
      if (res.ok && data?.data) {
        const normalized = data.data.map((s) => {
          return {
            ...s,
            exercise_id: s.exercise_id || null, // Keep only the exercise_id (not the full object)
          };
        });

        console.log("Normalized sprints:", normalized);
        setSprints(normalized); // Update state with the normalized spr
      } else {
        console.error("Failed to fetch sprints:", data?.message);
      }
    } catch (err) {
      console.error("Error fetching sprints:", err);
    }
  };

  useEffect(() => {
    if (template_id && exerciseOptions.length > 0) {
      fetchSprints();
    }
  }, [template_id, exerciseOptions]);

  const navigate = useNavigate(); // Initialize navigation

  // Fetch existing training focus template
  useEffect(() => {
    const fetchData = async () => {
      if (!template_id || !staff?.token) return;

      try {
        setIsLoading(true);
        const res = await fetch(
          `${API_URL.ADMIN_GET_SPEED_TEMPLATE_TRAINING_FOCUS_TEMPLATE}${template_id}`,
          {
            headers: {
              Authorization: `Bearer ${staff.token}`,
            },
          },
        );

        const data = await res.json();
        if (res.ok && data?.data) {
          setTrainingFocus(data.data.training_focus || "");
          setTrainingPhase(data.data.training_phase || "");
        } else {
          alert("Failed to fetch template.");
        }
      } catch (err) {
        console.error("Error fetching training focus template:", err);
        alert("Something went wrong.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [template_id, staff?.token]);

  const saveField = async (field, value) => {
    try {
      const body = {
        training_focus: field === "training_focus" ? value : trainingFocus,
        training_phase: field === "training_phase" ? value : trainingPhase,
      };

      const res = await fetch(
        API_URL.ADMIN_SAVE_SPEED_TEMPLATE_TRAINING_FOCUS_AND_TRAINING_PHASE +
          template_id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff.token}`,
          },
          body: JSON.stringify(body),
        },
      );

      if (res.ok) {
        setSaveStatus("Saved!");
        if (field === "training_focus") {
          setTrainingFocus(value);
          setEditingFocus(false);
        } else {
          setTrainingPhase(value);
          setEditingPhase(false);
        }
      } else {
        setSaveStatus("Failed to save.");
      }
    } catch (error) {
      console.error("Error saving:", error);
      setSaveStatus("Error occurred.");
    }
  };

  useEffect(() => {
    if (saveStatus) {
      const timer = setTimeout(() => {
        setSaveStatus("");
      }, 3000); // Message disappears after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [saveStatus]);

  const handleSprintDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const oldIndex = sprints.findIndex((sprint) => sprint._id === active.id);
    const newIndex = sprints.findIndex((sprint) => sprint._id === over.id);

    if (oldIndex !== -1 && newIndex !== -1) {
      const updated = [...sprints];
      const [movedSprint] = updated.splice(oldIndex, 1);
      updated.splice(newIndex, 0, movedSprint);
      setSprints(updated);
    }
  };

  const totalDistance = sprints.reduce((sum, sprint) => {
    if (sprint.type === "Rest") return sum;

    const sets = parseFloat(sprint.sets) || 0;
    const reps = parseFloat(sprint.reps) || 0;
    const distance = parseFloat(sprint.distance) || 0;

    return sum + sets * reps * distance;
  }, 0);

  return (
    <div className="flex md:h-screen font-inter">
      <StaffSideMenu />
      <div className="max-md:w-full md:flex-1 md:flex md:flex-col md:overflow-hidden md:overflow-y-auto bg-bgBase">
        {/* Go Back Button */}
        <div className="bg-white pt-5 pb-3 md:py-6 px-5 md:px-10">
          <div className="w-full max-w-screen-xl flex max-md:flex-col justify-between md:items-center gap-5">
            <button
              onClick={() => navigate(-1)}
              className="text-slate100 font-inter font-normal text-sm leading-tight flex items-center gap-2 hover:underline max-md:ml-12"
            >
              <GoArrowLeft color="#666666" /> Go Back
            </button>

            <h2 className="text-dark text-2xl font-medium">
              Sprint Configurations
            </h2>

            <div className="max-md:hidden"></div>
          </div>
        </div>

        <div className="py-4 md:py-6 px-5 md:px-10">
          <div className="w-full max-w-screen-xl">
            {/* Form */}
            <div className="bg-white border border-tblBorder rounded-10 p-5 md:p-6 mb-8">
              {isLoading ? (
                <div className="bg-gray-100 p-3 rounded text-dark font-normal text-sm">
                  <p>Loading...</p>
                </div>
              ) : (
                <>
                  <div className="w-full flex max-lg:flex-col gap-4">
                    {/* Training Focus */}
                    <div className="flex-1 lg:mb-6">
                      <label className="block text-dark text-sm font-medium mb-1">
                        Training Focus
                      </label>
                      {editingFocus ? (
                        <div className="flex flex-col gap-2">
                          <input
                            type="text"
                            className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                            value={tempFocus}
                            onChange={(e) => setTempFocus(e.target.value)}
                          />
                          <div className="flex items-center gap-2">
                            <button
                              className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                              onClick={() =>
                                saveField("training_focus", tempFocus)
                              }
                            >
                              Save
                            </button>
                            <button
                              className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                              onClick={() => setEditingFocus(false)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="w-full relative mt-2 border border-tblBorder p-3 !pr-12 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight flex justify-between gap-5">
                          <p className="text-gray-700">
                            {trainingFocus || "—"}
                          </p>
                          <button
                            onClick={() => {
                              setTempFocus(trainingFocus);
                              setEditingFocus(true);
                            }}
                            className="flex-none absolute top-2 right-3 p-1 rounded hover:bg-gray-200"
                          >
                            <FiEdit2 color="#666666" size={18} />
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Training Phase */}
                    <div className="flex-1 lg:mb-6">
                      <label className="block text-dark text-sm font-medium mb-1">
                        Training Phase
                      </label>
                      {editingPhase ? (
                        <div className="flex flex-col gap-2">
                          <input
                            type="text"
                            className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                            value={tempPhase}
                            onChange={(e) => setTempPhase(e.target.value)}
                          />
                          <div className="flex items-center gap-2">
                            <button
                              className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                              onClick={() =>
                                saveField("training_phase", tempPhase)
                              }
                            >
                              Save
                            </button>
                            <button
                              className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                              onClick={() => setEditingPhase(false)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="w-full relative mt-2 border border-tblBorder p-3 !pr-12 rounded-10 flex justify-between gap-5">
                          <p className="text-sm font-inter font-normal leading-tight">
                            {trainingPhase || "—"}
                          </p>
                          <button
                            onClick={() => {
                              setTempPhase(trainingPhase);
                              setEditingPhase(true);
                            }}
                            className="flex-none absolute top-2 right-3 p-1 rounded hover:bg-gray-200"
                          >
                            <FiEdit2 color="#666666" size={16} />
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="flex-none lg:mt-7">
                      <button
                        onClick={saveTemplate}
                        className={`px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm rounded-lg hover:bg-black ${
                          isSavingTemplate
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={isSavingTemplate}
                      >
                        {isSavingTemplate ? "Saving..." : "Save Template"}
                      </button>
                    </div>
                  </div>

                  {saveStatus && (
                    <div className="mt-4 bg-green-100 text-green-800 text-sm px-4 py-2 rounded border border-green-300">
                      {saveStatus}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Add Sprint / Reorder Sprints / Add Rest */}
            <div className="flex max-lg:flex-col justify-between gap-3 lg:gap-5 mb-3">
              {/* Total distance label */}
              <p className="text-dark text-s font-medium">
                Total Distance:{" "}
                <span className="text-slate100 font-normal text-xs">
                  {totalDistance} m
                </span>
              </p>

              <div className="flex flex-wrap items-center gap-2 lg:gap-3">
                {/* Add Sprint */}
                <button
                  onClick={addSprintRow}
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                >
                  <MdAdd color="#000" /> Add Sprint
                </button>
                {/* Add Reorder Sprints Button */}
                <button
                  onClick={() => setReorderMode(!reorderMode)}
                  className={` px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl`}
                >
                  {reorderMode ? (
                    "Back to Editor"
                  ) : (
                    <>
                      <DotedSvg /> Reorder Sprints
                    </>
                  )}
                </button>
                {/* Add Rest Button */}
                {showRestForm ? (
                  <></>
                ) : (
                  <>
                    <button
                      onClick={() => setShowRestForm(!showRestForm)}
                      className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                    >
                      <MdAdd color="#000" /> Add Rest
                    </button>
                  </>
                )}
              </div>
            </div>
            {/* Rest Form */}
            {showRestForm && (
              <div className="bg-white border border-tblBorder rounded-10 p-4 my-4">
                <div className="mb-2">
                  <label className="block text-dark text-sm font-medium mb-1">
                    Rest Notes
                  </label>
                  <textarea
                    value={restNotes}
                    onChange={(e) => setRestNotes(e.target.value)}
                    className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-snug outline-none"
                    rows={2}
                  />
                </div>
                <div className="flex flex-wrap gap-1 sm:gap-3">
                  <button
                    onClick={addRestRow}
                    className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                  >
                    Save Rest Data
                  </button>
                  <button
                    className="px-6 py-2.5 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white"
                    onClick={() => setShowRestForm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {/* Warmup Data Placeholder (70%) */}
            {/* Display Warmup Phases & Exercises */}
            <div className="md:max-h-[550px] md:show-scrollbar overflow-y-scroll">
              {reorderMode ? (
                <div className="space-y-4">
                  <h3 className="text-lg font-medium mb-2">Reorder Sprints</h3>

                  <DndContext onDragEnd={(event) => handleSprintDragEnd(event)}>
                    {sprints.map((sprint, index) => (
                      <DroppableSprint key={sprint._id} id={sprint._id}>
                        <DraggableSprintItem
                          key={sprint._id}
                          id={sprint._id}
                          sprintIndex={index}
                          sprint={sprint}
                        />
                      </DroppableSprint>
                    ))}
                  </DndContext>
                </div>
              ) : (
                <>
                  {sprints.length === 0 && (
                    <p className="text-gray-500 italic">
                      No sprints added yet.
                    </p>
                  )}

                  {sprints.map((sprint, index) => {
                    const selectedExercise = exerciseOptions.find(
                      (exercise) =>
                        exercise._id ===
                        (sprint.exercise_id &&
                        typeof sprint.exercise_id === "object"
                          ? sprint.exercise_id._id
                          : sprint.exercise_id),
                    );

                    const extractYouTubeId = (url) => {
                      if (!url) return null;

                      const regex =
                        /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:shorts\/|watch\?.*v=|embed\/|v\/|.*[?&]v=))([\w-]{11})/;

                      const match = url.match(regex);
                      return match ? match[1] : null;
                    };

                    const extractYouTubeThumbnail = (url) => {
                      const id = extractYouTubeId(url);
                      return id
                        ? `https://img.youtube.com/vi/${id}/hqdefault.jpg`
                        : null;
                    };

                    const thumbnail = selectedExercise?.video_url
                      ? extractYouTubeThumbnail(selectedExercise.video_url)
                      : null;
                    return (
                      <>
                        {sprint.type === "Rest" ? (
                          <div
                            key={index}
                            className="mb-3 p-3 border rounded-md bg-gray-50 flex justify-between items-center"
                          >
                            <div>
                              <div className="block text-slate100 text-sm font-medium leading-tight">
                                Rest Notes: {sprint.rest_notes || "None"}
                              </div>
                            </div>
                            <button
                              onClick={() => deleteSprintRow(index)}
                              className="p-2 rounded-md hover:bg-gray-200"
                            >
                              <RiDeleteBin4Line color="#666666" size={20} />
                            </button>
                          </div>
                        ) : (
                          <div
                            key={index}
                            className="mb-4 border rounded-10 bg-gray-50"
                          >
                            {/* Exercise */}
                            {openRows[index] && (
                              <div className={`${openRows[index]  ? "border-b" : ""}  border-tblBorder`}>
                                {/* Exercise Dropdown (full width below row) */}
                                <div className="flex justify-between items-end gap-2 md:gap-5 p-4">
                                  <SingleSelectExerciseList
                                    value={
                                      sprint.exercise_id
                                        ? typeof sprint.exercise_id === "object"
                                          ? sprint.exercise_id._id
                                          : sprint.exercise_id
                                        : null
                                    }
                                    onChange={(newVal) => {
                                      const updated = [...sprints];
                                      updated[index].exercise_id =
                                        newVal || null;
                                      setSprints(updated);
                                    }}
                                    exercises={exerciseOptions}
                                    resetTrigger={resetTrigger}
                                  />
                                  {/* Delete button / open close btn */}
                                  <div className="flex-none">
                                    <button
                                      onClick={() => deleteSprintRow(index)}
                                      className="p-2 rounded-md hover:bg-gray-200"
                                    >
                                      <RiDeleteBin4Line
                                        color="#666666"
                                        size={20}
                                      />
                                    </button>

                                    <button
                                      onClick={() => toggleRow(index)}
                                      className="p-2 rounded hover:bg-gray-200"
                                    >
                                      {openRows[index] ? (
                                        <MdKeyboardArrowUp
                                          color="#6A7282"
                                          size={20}
                                        />
                                      ) : (
                                        <MdKeyboardArrowDown
                                          color="#6A7282"
                                          size={20}
                                        />
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* set / reps / notes */}
                            <div className="flex flex-wrap gap-3 p-4">
                              <div className="flex-none">
                                <div className="w-12 h-12 lg:w-16 lg:h-16 shrink-0">
                                  {openRows[index] ||
                                    (sprint.exercise_id && (
                                      <>
                                        <img
                                          src={thumbnail}
                                          alt={
                                            selectedExercise?.title ||
                                            "Exercise Thumbnail"
                                          }
                                          className="w-12 h-12 object-cover rounded-md border border-tblBorder"
                                        />
                                      </>
                                    ))}
                                </div>
                              </div>
                              <div className="flex-1 flex flex-wrap gap-3">
                                {/* Sets */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Sets
                                  </label>
                                  <select
                                    value={sprint.sets}
                                    onChange={(e) => {
                                      const updated = [...sprints];
                                      updated[index].sets = parseInt(
                                        e.target.value,
                                      );
                                      setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {range(1, 15).map((num) => (
                                      <option key={num} value={num}>
                                        {num}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Reps */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Reps
                                  </label>
                                  <select
                                    value={sprint.reps}
                                    onChange={(e) => {
                                      const updated = [...sprints];
                                      updated[index].reps = parseInt(
                                        e.target.value,
                                      );
                                      setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {range(1, 15).map((num) => (
                                      <option key={num} value={num}>
                                        {num}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Distance */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Distance (m)
                                  </label>
                                  <select
                                    value={sprint.distance}
                                    onChange={(e) => {
                                      const updated = [...sprints];
                                      updated[index].distance = parseInt(
                                        e.target.value,
                                      );
                                      setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {distances.map((d) => (
                                      <option key={d} value={d}>
                                        {d}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Pace */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Pace
                                  </label>
                                  <select
                                    value={sprint.pace}
                                    onChange={(e) => {
                                      const updated = [...sprints];
                                      updated[index].pace = parseInt(
                                        e.target.value,
                                      );
                                      setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {paces.map((p) => (
                                      <option key={p} value={p}>
                                        {p}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Intensity */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Intensity (%)
                                  </label>
                                  <select
                                    value={sprint.intensity}
                                    onChange={(e) => {
                                      const updated = [...sprints];
                                      updated[index].intensity = parseInt(
                                        e.target.value,
                                      );
                                      setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {intensities.map((i) => (
                                      <option key={i} value={i}>
                                        {i}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                {/* Rest */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Rest
                                  </label>
                                  <input
                                    type="text"
                                    value={sprint.rest}
                                    onChange={(e) => {
                                      const updated = [...sprints];
                                      updated[index].rest = e.target.value;
                                      setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                    placeholder="Enter rest duration"
                                  />
                                  {/* <select
                                    value={sprint.rest}
                                    onChange={(e) => {
                                    const updated = [...sprints];
                                    updated[index].rest = e.target.value;
                                    setSprints(updated);
                                    }}
                                    className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                >
                                    {rests.map((r) => (
                                    <option key={r} value={r}>{r}</option>
                                    ))}
                                </select>
                              */}
                                </div>
                              </div>
                              <div className="flex-none flex items-start lg:items-center">
                                {openRows[index] ? (
                                  <>
                                    <div className="opacity-0">
                                      <button
                                        onClick={() => deleteSprintRow(index)}
                                        className="p-2 rounded-md hover:bg-gray-200"
                                      >
                                        <RiDeleteBin4Line
                                          color="#666666"
                                          size={20}
                                        />
                                      </button>

                                      <button
                                        onClick={() => toggleRow(index)}
                                        className="p-2 rounded hover:bg-gray-200"
                                      >
                                        {openRows[index] ? (
                                          <MdKeyboardArrowUp
                                            color="#6A7282"
                                            size={20}
                                          />
                                        ) : (
                                          <MdKeyboardArrowDown
                                            color="#6A7282"
                                            size={20}
                                          />
                                        )}
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      onClick={() => deleteSprintRow(index)}
                                      className="p-2 rounded-md hover:bg-gray-200"
                                    >
                                      <RiDeleteBin4Line
                                        color="#666666"
                                        size={20}
                                      />
                                    </button>

                                    <button
                                      onClick={() => toggleRow(index)}
                                      className="p-2 rounded hover:bg-gray-200"
                                    >
                                      {openRows[index] ? (
                                        <MdKeyboardArrowUp
                                          color="#6A7282"
                                          size={20}
                                        />
                                      ) : (
                                        <MdKeyboardArrowDown
                                          color="#6A7282"
                                          size={20}
                                        />
                                      )}
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                            {openRows[index] && (
                              <>
                                {/* Notes Field */}
                                <div className="text-slate100 font-normal text-xs flex flex-wrap gap-3 p-4 border-t border-tblBorder">
                                  <div className="flex-none max-sm:hidden">
                                    <div className="w-12 h-12 lg:w-16 lg:h-16 shrink-0"></div>
                                  </div>
                                  <div className="flex-1">
                                    <label className="block text-slate100 text-xs font-normal">
                                      Notes
                                    </label>
                                    <textarea
                                      value={sprint.notes || ""}
                                      onChange={(e) => {
                                        const updated = [...sprints];
                                        updated[index].notes = e.target.value;
                                        setSprints(updated);
                                      }}
                                      placeholder="Add notes about this block..."
                                      className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-snug outline-none"
                                      rows={2}
                                    />
                                  </div>
                                  <div className="flex-none max-sm:hidden">
                                    <div className="w-[72px]"></div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const DraggableSprintItem = ({ sprintIndex, id, sprint }) => {
  const navigate = useNavigate();
  const [dragMode, setDragMode] = useState(true);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none", // Smooth transition when not dragging
      }
    : undefined;

  return (
    <>
      <div
        ref={setNodeRef}
        {...attributes}
        {...(dragMode ? listeners : {})} // Apply listeners when dragMode is true  // Apply listeners only when dragMode is true
        style={style}
      >
        <div key={sprintIndex} className="">
          {sprint.type === "Rest" ? (
            <div className="bg-white border border-tblBorder shadow rounded-10 space-y-3 p-4">
              <p className="text-sm text-slate100 font-normal">
                Notes: {sprint.rest_notes || "None"}
              </p>
            </div>
          ) : (
            <>
              <div className="bg-white border border-tblBorder shadow rounded-10 space-y-3 p-4">
                <div className="flex justify-between gap-5">
                  <p></p>
                  <div className="flex gap-1">
                    <p className="text-dark font-medium text-sm">
                      {sprint.distance}m
                    </p>
                    <p className="text-dark font-medium text-sm">.</p>
                    <p className="text-dark font-medium text-sm">
                      {sprint.intensity}%
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-x-5 gap-y-2">
                  <div className="flex-1 min-w-20">
                    <span className="text-slate100 font-normal text-xs">
                      Sets:
                    </span>{" "}
                    <p className="text-dark font-medium text-sm mt-1">
                      {sprint.sets}
                    </p>
                  </div>
                  <div className="flex-1 min-w-20">
                    <span className="text-slate100 font-normal text-xs">
                      Reps:
                    </span>{" "}
                    <p className="text-dark font-medium text-sm mt-1">
                      {sprint.reps}
                    </p>
                  </div>
                  <div className="flex-1 min-w-20">
                    <span className="text-slate100 font-normal text-xs">
                      Distance:{" "}
                    </span>{" "}
                    <p className="text-dark font-medium text-sm mt-1">
                      {sprint.distance}m
                    </p>
                  </div>
                  <div className="flex-1 min-w-20">
                    <span className="text-slate100 font-normal text-xs">
                      Pace:
                    </span>{" "}
                    <p className="text-dark font-medium text-sm mt-1">
                      {sprint.pace}
                    </p>
                  </div>
                  <div className="flex-1 min-w-20">
                    <span className="text-slate100 font-normal text-xs">
                      Intensity:
                    </span>{" "}
                    <p className="text-dark font-medium text-sm mt-1">
                      {sprint.intensity}%
                    </p>
                  </div>
                  <div className="flex-1 min-w-20">
                    <span className="text-slate100 font-normal text-xs">
                      Rest:
                    </span>{" "}
                    <p className="text-dark font-medium text-sm mt-1">
                      {sprint.rest}
                    </p>
                  </div>
                </div>
                <div className="pt-2.5 border-t border-tblBorder flex items-center gap-1.5">
                  <p className="text-sm text-slate100 font-normal">
                    Notes: {sprint.notes}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const DroppableSprint = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } p-4 rounded-md`}
    >
      {children}
    </div>
  );
};
